<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.08301 1.23071C10.4426 1.23071 13.1668 3.95414 13.167 7.31372C13.1669 8.72322 12.6856 10.0195 11.8809 11.051L14.2803 13.4504L14.3311 13.5071C14.5715 13.8017 14.5549 14.2363 14.2803 14.511C14.0056 14.7855 13.5709 14.8021 13.2764 14.5618L13.2197 14.511L10.8203 12.1116C9.78875 12.9163 8.49248 13.3977 7.08301 13.3977C3.72351 13.3975 1.00013 10.6732 1 7.31372C1.00018 3.95425 3.72353 1.23089 7.08301 1.23071ZM7.08301 2.73071C4.55196 2.73089 2.50018 4.78267 2.5 7.31372C2.50013 9.8448 4.55193 11.8975 7.08301 11.8977C9.61423 11.8977 11.6669 9.84491 11.667 7.31372C11.6668 4.78257 9.6142 2.73071 7.08301 2.73071Z" fill="#627280"/>
  </svg>
</template>

<script setup lang="ts">

</script>
